'use client'
import {
  useConfig_default
} from "./chunk-UDUUTZIS.mjs";

// src/hooks/useWalletConfig.ts
var useWalletConfig = () => {
  const { wallet } = useConfig_default();
  return wallet || {};
};

export {
  useWalletConfig
};
//# sourceMappingURL=chunk-SZVMOVE4.mjs.map